import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import AuthInput from "../AuthInput";

const CreatePasswordStep = ({
  step,
  submitLabel = "Create Password",
  onSubmit,
  onBack,
  setError,
  loading,
  error,
}) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <div>
      <AuthInput
        name="newPassword"
        setError={setError}
        type={showPassword ? "text" : "password"}
        value={password}
        setValue={setPassword}
        step={step}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Enter new password"
        rightIcon={
          showPassword ? (
            <Eye
              size={16}
              className="cursor-pointer"
              onClick={() => setShowPassword(false)}
            />
          ) : (
            <EyeOff
              size={16}
              className="cursor-pointer"
              onClick={() => setShowPassword(true)}
            />
          )
        }
        error={error}
      />

      <div className="pt-4">
        <AuthInput
          name="confirmPassword"
          setError={setError}
          type={showConfirmPassword ? "text" : "password"}
          value={confirmPassword}
          step={step}
          setValue={setConfirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm new password"
          rightIcon={
            showConfirmPassword ? (
              <Eye
                size={16}
                className="cursor-pointer"
                onClick={() => setShowConfirmPassword(false)}
              />
            ) : (
              <EyeOff
                size={16}
                className="cursor-pointer"
                onClick={() => setShowConfirmPassword(true)}
              />
            )
          }
          error={error}
        />
      </div>

      <div className="w-full sm:w-[50%] m-auto flex justify-end pt-3">
        <button
          type="button"
          onClick={() => onSubmit(password, confirmPassword)}
          disabled={loading}
          className="cursor-pointer outline-none text-xs bg-buttonColor text-white py-3 px-5 rounded-md"
        >
          {loading ? "Please wait..." : submitLabel}
        </button>
      </div>

      <p className="w-full sm:w-[100%] m-auto text-sm text-primary text-center pt-4">
        Password must be at least 8 characters and include{" "}
        <span className="font-semibold">
          1 uppercase letter (A-Z, e.g., A)
        </span>
        , <span className="font-semibold">1 number (0-9, e.g., 7)</span>, and{" "}
        <span className="font-semibold">
          1 special character (! @ # $ % &)
        </span>
        .
      </p>
    </div>
  );
};

export default CreatePasswordStep;
